
import { ShoppingBag, Info, Mail } from "lucide-react";

export const mainMenuItems = [
  { icon: ShoppingBag, label: "Marketplace", path: "/services" },
  { icon: Info, label: "À propos", path: "/about" },
  { icon: Mail, label: "Contact", path: "/contact" },
];
